import { Component, inject, viewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrganizationGridItemObject } from '@it2go/types';
import { OrganizationsPageStore } from './organizations-page.store';
import { isAllowed } from '../../../../shared/shared.global-service';
import { dateField } from '../../../../shared/components/kit/table/table.fields';
import { TableComponent } from '../../../../shared/components/kit/table/table.component';
import {
    FileUploadButtonComponent,
} from '../../../../../components/kit/file-upload-button/file-upload-button.component';
import {
    FileUploadProgress,
    FileUploadProgressStatus,
} from '../../../../../components/kit/file-upload-button/file-upload-button.types';
import { contentGlobalErrors, contentGlobalInfo, contentGlobalSuccess, successDeleted } from '../../../content.error';
import { ConfirmBuilder } from '../../../../shared/service/confirm.builder';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { FormatPersonPipe } from '../../../../shared/pipes/format-person.pipe';
import { FormatAddressPipe } from '../../../../shared/pipes/format-address.pipe';

@Component({
    selector: 'app-organizations',
    templateUrl: 'organizations-page.component.html',
    providers: [OrganizationsPageStore],
    imports: [
        TableComponent,
        FileUploadButtonComponent,
        PrimeTemplate,
        FormatPersonPipe,
        FormatAddressPipe,
    ],
})
export class OrganizationsPageComponent {

    public readonly store = inject(OrganizationsPageStore);
    public readonly router = inject(Router);
    public readonly route = inject(ActivatedRoute);
    protected readonly confirm = inject(ConfirmBuilder);

    protected readonly table = viewChild(TableComponent);

    protected prefix = 'organization.';

    protected columns = [
        {
            name: 'name',
            filterable: true,
        },
        { name: 'address' },
        // { name: 'workersCount' },
        // { name: 'workingDaysCount' },
        // { name: 'sizeOfFiles' },
        // { name: 'sizeOfDatabase' },
        { name: 'representativePerson' },
        { name: 'contactPerson' },
        dateField('systemFrom', false, false),
        dateField('systemTo', false, false),
    ];

    goToCreate() {
        return this.router.navigate(['./create'], { relativeTo: this.route });
    }

    goToDetail(organization: OrganizationGridItemObject) {
        return this.router.navigate([`./${organization.id}`], { relativeTo: this.route });
    }

    protected async delete(event: any): Promise<void> {
        this.confirm.confirmDelete(
            async () => {
                await this.store.api.deleteOrganization({ id: event.item.id });
                successDeleted();
                this.table()?.reload();
            },
            event,
        );
    }

    onImportProgress(e: FileUploadProgress) {
        if (e.status === FileUploadProgressStatus.STARTED) {
            contentGlobalInfo.next('organization.import.started');
        }

        if (e.status === FileUploadProgressStatus.COMPLETED_CALLBACK) {
            contentGlobalSuccess.next('organization.import.completed');
            this.table()?.reload();
        }

        if (e.status === FileUploadProgressStatus.FAILED) {
            contentGlobalErrors.next('organization.import.failed');
        }
    }

    protected readonly isAllowed = isAllowed;
}
